"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3443],{

/***/ 83443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FormattedDate": function() { return /* binding */ FormattedDate; },
  "FormattedDateParts": function() { return /* binding */ FormattedDateParts; },
  "FormattedDateTimeRange": function() { return /* reexport */ dateTimeRange; },
  "FormattedDisplayName": function() { return /* binding */ FormattedDisplayName; },
  "FormattedList": function() { return /* binding */ FormattedList; },
  "FormattedListParts": function() { return /* reexport */ FormattedListParts; },
  "FormattedMessage": function() { return /* reexport */ message/* default */.Z; },
  "FormattedNumber": function() { return /* binding */ FormattedNumber; },
  "FormattedNumberParts": function() { return /* reexport */ FormattedNumberParts; },
  "FormattedPlural": function() { return /* reexport */ plural; },
  "FormattedRelativeTime": function() { return /* reexport */ relative; },
  "FormattedTime": function() { return /* binding */ FormattedTime; },
  "FormattedTimeParts": function() { return /* binding */ FormattedTimeParts; },
  "IntlContext": function() { return /* reexport */ injectIntl/* Context */._y; },
  "IntlProvider": function() { return /* reexport */ provider/* default */.Z; },
  "InvalidConfigError": function() { return /* reexport */ error/* InvalidConfigError */.OV; },
  "MessageFormatError": function() { return /* reexport */ error/* MessageFormatError */.X9; },
  "MissingDataError": function() { return /* reexport */ error/* MissingDataError */.gb; },
  "MissingTranslationError": function() { return /* reexport */ error/* MissingTranslationError */.$6; },
  "RawIntlProvider": function() { return /* reexport */ injectIntl/* Provider */.zt; },
  "ReactIntlError": function() { return /* reexport */ error/* IntlError */.Rw; },
  "ReactIntlErrorCode": function() { return /* reexport */ error/* IntlErrorCode */.bc; },
  "UnsupportedFormatterError": function() { return /* reexport */ error/* UnsupportedFormatterError */.wI; },
  "createIntl": function() { return /* reexport */ provider/* createIntl */.d; },
  "createIntlCache": function() { return /* reexport */ src_utils/* createIntlCache */.Sn; },
  "defineMessage": function() { return /* binding */ defineMessage; },
  "defineMessages": function() { return /* binding */ defineMessages; },
  "injectIntl": function() { return /* reexport */ injectIntl/* default */.ZP; },
  "useIntl": function() { return /* reexport */ useIntl/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/createFormattedComponent.js



var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) {
    var intl = (0,useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function (props) {
    var intl = (0,useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) {
        var intl = (0,useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) {
        var intl = (0,useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props
        // TODO: fix TS type definition for localeMatcher upstream
        , ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(74806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/provider.js + 8 modules
var provider = __webpack_require__(64720);
// EXTERNAL MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
var utils = __webpack_require__(25687);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/relative.js

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */



var MINUTE = 60;
var HOUR = 60 * 60;
var DAY = 60 * 60 * 24;
function selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < MINUTE) {
        return 'second';
    }
    if (absValue < HOUR) {
        return 'minute';
    }
    if (absValue < DAY) {
        return 'hour';
    }
    return 'day';
}
function getDurationInSeconds(unit) {
    switch (unit) {
        case 'second':
            return 1;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        default:
            return DAY;
    }
}
function valueToSeconds(value, unit) {
    if (!value) {
        return 0;
    }
    switch (unit) {
        case 'second':
            return value;
        case 'minute':
            return value * MINUTE;
        default:
            return value * HOUR;
    }
}
var INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour',
];
function canIncrement(unit) {
    if (unit === void 0) { unit = 'second'; }
    return INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var SimpleFormattedRelativeTime = function (props) {
    var _a = (0,useIntl/* default */.Z)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0,tslib_es6/* __rest */._T)(props, ["children", "value", "unit"]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') {
        return children(formattedRelativeTime);
    }
    if (Text) {
        return react.createElement(Text, null, formattedRelativeTime);
    }
    return react.createElement(react.Fragment, null, formattedRelativeTime);
};
var FormattedRelativeTime = function (_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0,tslib_es6/* __rest */._T)(_a, ["value", "unit", "updateIntervalInSeconds"]);
    (0,utils/* invariant */.kG)(!updateIntervalInSeconds ||
        !!(updateIntervalInSeconds && canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = react.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = react.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = react.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds(canIncrement(unit) ? valueToSeconds(value, unit) : 0);
    }
    react.useEffect(function () {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !canIncrement(unit)) {
            return clearUpdateTimer;
        }
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') {
            return clearUpdateTimer;
        }
        var unitDuration = getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds
            ? prevInterestingValueInSeconds - unitDuration
            : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) {
            updateTimer = setTimeout(function () { return setCurrentValueInSeconds(nextInterestingValueInSeconds); }, delayInSeconds * 1e3);
        }
        return clearUpdateTimer;
    }, [currentValueInSeconds, updateIntervalInSeconds, unit]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if (canIncrement(unit) &&
        typeof currentValueInSeconds === 'number' &&
        updateIntervalInSeconds) {
        currentUnit = selectUnit(currentValueInSeconds);
        var unitDuration = getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return (react.createElement(SimpleFormattedRelativeTime, (0,tslib_es6/* __assign */.pi)({ value: currentValue, unit: currentUnit }, otherProps)));
};
FormattedRelativeTime.displayName = 'FormattedRelativeTime';
FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second',
};
/* harmony default export */ var relative = (FormattedRelativeTime);

;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/plural.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */


var FormattedPlural = function (props) {
    var _a = (0,useIntl/* default */.Z)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') {
        return children(formattedPlural);
    }
    if (Text) {
        return react.createElement(Text, null, formattedPlural);
    }
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
FormattedPlural.defaultProps = {
    type: 'cardinal',
};
FormattedPlural.displayName = 'FormattedPlural';
/* harmony default export */ var plural = (FormattedPlural);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/dateTimeRange.js



var FormattedDateTimeRange = function (props) {
    var intl = (0,useIntl/* default */.Z)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["from", "to", "children"]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') {
        return children(formattedValue);
    }
    var Text = intl.textComponent || react.Fragment;
    return react.createElement(Text, null, formattedValue);
};
FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
/* harmony default export */ var dateTimeRange = (FormattedDateTimeRange);

// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(82644);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(88222);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/index.js










function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = createFormattedComponent('formatDate');
var FormattedTime = createFormattedComponent('formatTime');
// @ts-ignore issue w/ TS Intl types
var FormattedNumber = createFormattedComponent('formatNumber');
var FormattedList = createFormattedComponent('formatList');
var FormattedDisplayName = createFormattedComponent('formatDisplayName');
var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime');



/***/ })

}]);